/**
 * Generic archive "Load More".
 *
 * Any button with `data-load-more` drives an AJAX append into the grid named by
 * `data-target`, for the post type in `data-post-type`. The grid carries
 * `data-next` / `data-max` / `data-term`. Config (ajaxUrl, nonce) comes from
 * `fhLoadMore` (wp_localize_script). Server side: inc/load-more.php.
 */
( function () {
	'use strict';

	// Visually-hidden aria-live region announcing each batch to screen reader
	// users, since aria-busy toggling alone isn't reliably announced as
	// "content added" by most AT/browser combinations.
	function createStatus( button ) {
		var status = document.createElement( 'div' );
		status.className = 'screen-reader-text';
		status.setAttribute( 'aria-live', 'polite' );
		status.setAttribute( 'role', 'status' );
		button.parentNode.insertBefore( status, button.nextSibling );
		return status;
	}

	function bind( button ) {
		var grid = document.querySelector( button.getAttribute( 'data-target' ) );
		if ( ! grid || typeof window.fhLoadMore === 'undefined' ) {
			return;
		}

		var postType = button.getAttribute( 'data-post-type' ) || '';
		var status   = createStatus( button );

		button.addEventListener( 'click', function () {
			if ( button.classList.contains( 'is-loading' ) ) {
				return;
			}

			var next = parseInt( grid.getAttribute( 'data-next' ), 10 ) || 2;
			var max = parseInt( grid.getAttribute( 'data-max' ), 10 ) || 1;
			var term = parseInt( grid.getAttribute( 'data-term' ), 10 ) || 0;

			button.classList.add( 'is-loading' );
			button.setAttribute( 'aria-busy', 'true' );

			var body = new URLSearchParams();
			body.append( 'action', 'fh_load_more' );
			body.append( 'nonce', window.fhLoadMore.nonce );
			body.append( 'post_type', postType );
			body.append( 'page', next );
			body.append( 'term', term );

			fetch( window.fhLoadMore.ajaxUrl, {
				method: 'POST',
				credentials: 'same-origin',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
				body: body.toString(),
			} )
				.then( function ( res ) {
					return res.json();
				} )
				.then( function ( response ) {
					button.classList.remove( 'is-loading' );
					button.removeAttribute( 'aria-busy' );

					if ( ! response || ! response.success ) {
						return;
					}

					var data = response.data;
					if ( data.html ) {
						var temp = document.createElement( 'div' );
						temp.innerHTML = data.html.trim();
						var added = temp.children.length;
						while ( temp.firstChild ) {
							grid.appendChild( temp.firstChild );
						}
						// Let the scroll-reveal engine animate newly added items.
						if ( typeof window.revealSection === 'function' ) {
							window.revealSection( grid );
						}
						if ( added > 0 ) {
							status.textContent = added === 1
								? window.fhLoadMore.oneLoaded
								: added + ' ' + window.fhLoadMore.moreLoaded;
						}
					}

					grid.setAttribute( 'data-next', data.next );

					if ( ! data.has_more || data.next > max ) {
						button.parentNode.removeChild( button );
					}
				} )
				.catch( function () {
					button.classList.remove( 'is-loading' );
					button.removeAttribute( 'aria-busy' );
				} );
		} );
	}

	function init() {
		var buttons = document.querySelectorAll( '[data-load-more]' );
		for ( var i = 0; i < buttons.length; i++ ) {
			bind( buttons[ i ] );
		}
	}

	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', init );
	} else {
		init();
	}
} )();
